export function breedListService(EntryIDService,reportdata) {
  'ngInject';
     let resultString = reportdata.resultString;

     let getBreedList = () =>  {
       var breedList = {};
       angular.forEach(resultString.resultCalls, function(value, key) {
           var breedCluster = value['breed'].split("^"); // ignore cluster
           var breed = breedCluster[0];
           // Count 'H', 'M', 'L', 'T' confidence
           // Exclude 'X'
           if (value['confFlag'] != 'X') {
               if (breedList[breed]) {
                   ++breedList[breed];
               } else {
                   breedList[breed] = 1;
               }
           } else {
               if (breedList['Mixed Breed Groups']) {
                   ++breedList['Mixed Breed Groups'];
               } else {
                   breedList['Mixed Breed Groups'] = 1;
               }
           }
       });
       return breedList;
    };
    return {
        getBreedList: getBreedList

        ,getSortedBreedList: function() {
            var breedList = [];
            angular.forEach(getBreedList(), function(value, key) {
                if (key != 'Mixed Breed Groups') {
                    breedList.push({
                        "breed": key,
                        "count": value,
                        "assetID": EntryIDService.getEntryID(key)
                    });
                }
            });

            breedList.sort(function(a, b) {
                var count = b.count - a.count;
                return count == 0 ? (b.breed < a.breed) : count;
            });

            if (getBreedList()['Mixed Breed Groups']) {
                breedList.push({
                    "breed": "Mixed Breed Groups",
                    "count": getBreedList()['Mixed Breed Groups'],
                    "assetID": EntryIDService.getEntryID("Mixed Breed Groups")
                });
            }
            return breedList;
        },
        // determine whether any resultCalls entry has 'T' trace evidence
        // return true - trace evidence; false - no trace evidence
        getTraceConfidence: function() {
            var traceConfidence = false;

            angular.forEach(resultString.resultCalls, function(value, key) {
                var breedCluster = value['breed'].split("^"); // ignore cluster
                var breed = breedCluster[0];

                var confFlag = value['confFlag'];
                if (confFlag == 'T') {
                    traceConfidence = true;
                }
            });
            return traceConfidence;
        }
  }
}



export default angular.module('mars.vet.services.breedlist',["ng"]).factory('BreedListService', breedListService).name;



// WEBPACK FOOTER //
// ./client/apps/dnareport/services/breedlist.service.js